import { commentsAtom, getCommentByIdAtom, getCommentsAtom } from '../comments/comments';
import { findPostByIdentifier, getPostsAtom } from '../posts/posts';
import { jotaiStore } from '../store';
import type { ContentEntityType } from './model';

export function getContentEntitiesAtom(type: ContentEntityType) {
    if (type === 'Post') return getPostsAtom();
    if (type === 'Comment') return getCommentsAtom();
    throw new Error(`Unknown content entity type for global atom: ${type}`);
}

export function findCachedEntity(type: ContentEntityType, identifier: string) {
    if (type === 'Post') return findPostByIdentifier(identifier);

    if (type === 'Comment') {
        const getCommentFn = jotaiStore.get(getCommentByIdAtom);
        return getCommentFn(identifier);
    }
    console.warn(`[findCachedEntity] Unknown or unsupported content entity type for cache lookup: ${type}`);
    return;
}
